import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseUrl } from 'src/app/framework/constants/url-constants';
import { FileUploadService } from '../shared/components/file-upload/file-upload.service';

@Injectable({
  providedIn: 'root'
})
export class PatientService {

  constructor(
    private readonly http: HttpClient,
    private readonly fileUploadService:FileUploadService    
    ) { }

    createPatient(payload) {
      return this.http.post<any>(`${BaseUrl.PATIENT}/patients/create-patient`, payload);
    }
      
    getPatientDetails(id) {
      const href = `${BaseUrl.PATIENT}/patients/${id}`;
      return this.http.get<any>(href);
    }  
  
    updatePatient(payload) {
      const href =`${BaseUrl.PATIENT}/patients/${payload.id}/update-profile`;
      return this.http.put(href, payload );
    }

    placeGenomeDataRequest(payload){
      const href =`${BaseUrl.PATIENT}/genome-data/test-request`;
      return this.http.post(href, payload );
    }

}
